import api from '@/utils/api'

export default {
  namespaced: true,
  state: {
    user: {},
  },
  getters: {
    isAuthenticated(state, getters) {
      return getters.user && (getters.user.id !== undefined)
    },
    isAdmin(state, getters) {
      return getters.user.role === 'Admin'
    },
    user(state) {
      return state.user
    },
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
  },
  actions: {
    async logIn({ commit, dispatch }, formValues) {
      try {
        const { data: { user } } = await api.post('/authentication/login', formValues)
        if (user) {
          commit('setUser', user)
        } else {
          commit('setUser', {})
        }
      } catch (err) {
        commit('setUser', {})
        throw err
      }
      dispatch('Favorites/setFavoritesCount', null, { root: true })
      dispatch('Messages/setUnreadCount', null, { root: true })
      dispatch('Messages/enableUnreadCountPolling', null, { root: true })
    },
    async logOut({ commit, dispatch }) {
      try {
        await api.post('/authentication/logout')
      } catch (err) {
        console.error(err)
      }
      commit('setUser', {})
      dispatch('Messages/disableUnreadCountPolling', null, { root: true })
    },
    setUser({ commit }, user) {
      commit('setUser', user)
    },
    async setLoggedInUser({ commit, dispatch }) {
      try {
        const { data: { user } } = await api.get('/authentication/me')
        if (user && user.id) {
          commit('setUser', user)
          dispatch('Messages/enableUnreadCountPolling', null, { root: true })
        } else {
          commit('setUser', {})
          dispatch('Messages/disableUnreadCountPolling', null, { root: true })
        }
      } catch (err) {
        console.log(err)
        // if (router.currentRoute.path !== '/login' && router.currentRoute.authRequired) {
        //   router.push('/login')
        // }
      }
    },
  },
}
